import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronRight, Globe, Shield, Leaf } from 'lucide-react';
import { FAQAccordion } from '../../components/FAQAccordion';
import { CTAStrip } from '../../components/CTAStrip';
import { InlineCostCalculator } from '../../components/InlineCostCalculator';
const faqs = [{
  question: 'Which countries do you ship to?',
  answer: 'We ship worldwide including Australia, Canada, USA, Europe, Africa, and the Middle East. Contact us for specific country availability.'
}, {
  question: 'Do you supply packing crates?',
  answer: 'Yes. We supply professional timber packing crates and marine-grade packaging materials suitable for international shipping.'
}, {
  question: 'How long does overseas shipping take?',
  answer: "Transit times vary by destination. Europe: 1–2 weeks. Australia/NZ: 6–10 weeks. USA/Canada: 3–5 weeks. We'll give you accurate estimates when you enquire."
}, {
  question: 'Do you handle customs documentation?',
  answer: 'Yes. We prepare all required customs documentation and can advise on import duties and regulations for your destination country.'
}, {
  question: 'Can you pack our belongings for us?',
  answer: 'Yes. Our professional packing service ensures your belongings are safely packed for the rigours of international shipping.'
}];
export function OverseasRemovalsPage() {
  return <div className="pt-16 lg:pt-20" data-id="element-1016">
      <section className="relative h-72 md:h-96 overflow-hidden" data-id="element-1017">
        <img src="https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=1600&auto=format&fit=crop" alt="Overseas removals" className="w-full h-full object-cover" data-id="element-1018" />
        <div className="absolute inset-0 hero-overlay" data-id="element-1019" />
        <div className="absolute inset-0 flex items-center" data-id="element-1020">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-1021">
            <nav className="flex items-center gap-2 text-green-200 text-sm mb-4" data-id="element-1022">
              <Link to="/" className="hover:text-white" data-id="element-1023">
                Home
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-1024" />
              <Link to="/services" className="hover:text-white" data-id="element-1025">
                Services
              </Link>
              <ChevronRight className="w-4 h-4" data-id="element-1026" />
              <span className="text-white" data-id="element-1027">Overseas Removals</span>
            </nav>
            <h1 className="text-3xl md:text-5xl font-extrabold text-white" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-1028">
              Overseas Removals & Migration Moves
            </h1>
            <p className="text-green-100 mt-3 text-lg" data-id="element-1029">
              Professional international removals from London. From £500.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-1030">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1031">
          <div data-id="element-1032">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-1033">
              What's Included
            </h2>
            <ul className="space-y-3" data-id="element-1034">
              {['Professional packing crates supplied', 'Marine-grade packaging materials', 'Full customs documentation', 'Door-to-door service', 'Container & groupage shipping', 'Insurance options available', 'Destination agent coordination', 'Unpacking service available'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-1035">
                  <CheckCircle className="w-5 h-5 flex-shrink-0" style={{
                color: '#1B8F4B'
              }} data-id="element-1036" />
                  <span className="text-gray-700" data-id="element-1037">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-1038">
            <div className="bg-green-50 rounded-2xl p-6 mb-6" data-id="element-1039">
              <Globe className="w-10 h-10 mb-3" style={{
              color: '#1B8F4B'
            }} data-id="element-1040" />
              <h3 className="text-xl font-bold text-gray-900 mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-1041">
                Worldwide Destinations
              </h3>
              <p className="text-gray-600 text-sm mb-4" data-id="element-1042">
                We ship to over 100 countries worldwide. Popular destinations
                include:
              </p>
              <div className="grid grid-cols-2 gap-2" data-id="element-1043">
                {['Australia', 'Canada', 'USA', 'New Zealand', 'South Africa', 'UAE', 'Europe', 'Caribbean'].map(dest => <div key={dest} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-1044">
                    <CheckCircle className="w-3 h-3" style={{
                  color: '#1B8F4B'
                }} data-id="element-1045" />{' '}
                    {dest}
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white" data-id="element-1046">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1047">
          <div className="rounded-2xl border-2 border-[#1B8F4B] p-8 mb-6" data-id="element-1048">
            <p className="text-4xl font-extrabold mb-2" style={{
            color: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-1049">
              From £500
            </p>
            <p className="text-gray-500 mb-6" data-id="element-1050">
              Guide price for a small overseas shipment. Full quote provided
              after survey.
            </p>
            <Link to="/contact" className="inline-block px-8 py-4 rounded-xl font-bold text-white transition-colors hover:opacity-90" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-1051">
              Request a Quote
            </Link>
          </div>
          <div className="flex justify-center gap-6" data-id="element-1052">
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-1053">
              <Shield className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-1054" />{' '}
              Licensed & Fully Insured
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-1055">
              <Leaf className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-1056" />{' '}
              Eco-Friendly Disposal
            </div>
          </div>
        </div>
      </section>

      <InlineCostCalculator defaultService="overseas" serviceName="Overseas Removals" data-id="element-1057" />

      <section className="py-16 px-4 bg-white" data-id="element-1058">
        <div className="max-w-3xl mx-auto" data-id="element-1059">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-1060">
            FAQs
          </h2>
          <FAQAccordion items={faqs} data-id="element-1061" />
        </div>
      </section>
      <CTAStrip heading="Planning an Overseas Move?" subheading="Get a free consultation. We reply within 30 minutes." data-id="element-1062" />
    </div>;
}